"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assignDates = void 0;
var lodash_1 = require("lodash");
var toDate = function (value) {
  return value ? new Date(value) : null;
};
function assignDates(object, source, properties) {
  return (0, lodash_1.assignWith)(object, (0, lodash_1.pick)(source, properties), toDate);
}
exports.assignDates = assignDates;
